import React from 'react';
import { motion } from 'framer-motion';
import { Crown, MapPin, Users, Clock } from 'lucide-react';
const stats = [{
  icon: Users,
  value: '500+',
  label: '甄选佳丽',
  sublabel: 'Verified Companions'
}, {
  icon: MapPin,
  value: '20+',
  label: '覆盖国家',
  sublabel: 'Countries Worldwide'
}, {
  icon: Crown,
  value: '5年+',
  label: '行业经验',
  sublabel: 'Years of Experience'
}, {
  icon: Clock,
  value: '24/7',
  label: '在线服务',
  sublabel: 'Online Service'
}];
export function About() {
  return <section className="py-24 bg-[#0A0A0A] relative overflow-hidden" data-id="element-1">
      {/* Decorative top line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" data-id="element-2" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-4">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[#D4AF37] tracking-[0.3em] uppercase text-sm mb-4" data-id="element-5">
            About Us · 关于我们
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif text-white mb-4" data-id="element-6">
            为什么选择 KKbaby
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="h-1 w-20 bg-[#D4AF37] mx-auto" data-id="element-7" />
        </div>

        {/* Brand Story */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20" data-id="element-8">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-9">
            <h3 className="text-2xl font-serif text-white" data-id="element-10">
              新加坡首选高端伴游平台
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-11">
              KKbaby
              是新加坡领先的高端伴游服务平台，致力于为每一位客户提供安全、私密、高品质的社交体验。我们严格筛选来自全球各地的优质佳丽，确保每一位伴游都经过真实身份认证和专业形象审核。
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-12">
              我们深知信任是一切的基础。因此，KKbaby
              坚持「无需定金，见面满意再付款」的服务承诺，让您在没有任何经济压力的情况下，自由选择心仪的伴侣。每一次相遇，都是一段精心安排的心动旅程。
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-13">
              无论您是商务出行需要优雅的社交陪伴，还是希望在狮城邂逅一段难忘的浪漫时光，KKbaby
              都能为您量身定制完美的体验方案。
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-14">
            <h3 className="text-2xl font-serif text-white" data-id="element-15">
              Singapore's Premier Companion Service
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-16">
              KKbaby is Singapore's leading premium companion platform,
              dedicated to providing safe, discreet, and high-quality social
              experiences. We carefully curate exceptional companions from
              around the world, ensuring every profile is verified and
              professionally vetted.
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-17">
              Trust is at the heart of everything we do. Our "No Deposit, Pay
              After Meeting" policy means you can browse and connect with
              complete peace of mind — no financial commitment until you're
              fully satisfied.
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-18">
              Whether you're seeking elegant company for a business event or
              looking for an unforgettable romantic encounter in the Lion City,
              KKbaby crafts bespoke experiences tailored to your desires.
            </p>
          </motion.div>
        </div>

        {/* Key Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-19">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center p-6 border border-[#222] bg-[#111]/50 backdrop-blur-sm" data-id="element-20">
              <stat.icon className="w-6 h-6 text-[#D4AF37] mx-auto mb-3" data-id="element-21" />
              <p className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-2" data-id="element-22">
                {stat.value}
              </p>
              <p className="text-white text-sm font-medium" data-id="element-23">{stat.label}</p>
              <p className="text-gray-500 text-xs mt-1" data-id="element-24">{stat.sublabel}</p>
            </motion.div>)}
        </div>

        {/* Brand Promise */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-20 text-center border border-[#D4AF37]/20 bg-[#D4AF37]/5 p-10 md:p-14" data-id="element-25">
          <p className="text-[#D4AF37] tracking-[0.2em] uppercase text-xs mb-4" data-id="element-26">
            Our Promise · 我们的承诺
          </p>
          <p className="text-xl md:text-2xl font-serif text-white leading-relaxed max-w-3xl mx-auto" data-id="element-27">
            "真实 · 安全 · 私密 · 满意"
          </p>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-28">
            每一位佳丽均经过严格的身份认证与形象审核，确保您所见即所得。我们承诺全程保护您的隐私，提供最安心的服务体验。
          </p>
          <p className="text-gray-500 mt-2 text-sm" data-id="element-29">
            Authentic · Safe · Discreet · Satisfying — Every companion is
            rigorously verified. Your privacy is our priority.
          </p>
        </motion.div>
      </div>
    </section>;
}